import * as React from 'react';
import { createUseStyles } from 'react-jss';
import ActivityFeedCard from 'components/Overview/ActivityCard/ActivityFeedCard';
import ExpiringSoonCard from 'components/Overview/ActivityCard/ExpiringSoonCard';
import { Theme } from 'helpers/theme';
import PageHeader from 'components/PageHeader';
import { createFragmentContainer, graphql } from 'react-relay';
import { OrgOverview_manager } from './__generated__/OrgOverview_manager.graphql';
import { OrgOverview_purchasedCourses } from './__generated__/OrgOverview_purchasedCourses.graphql';
import { useRouter } from 'found';
import StatusCard from 'components/Overview/StatusCard/StatusCard';

const useStyles = createUseStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1
  },
  grid: {
    padding: '0px 40px 30px 40px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  feedRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '13px',
    '@media (max-width: 1150px)': {
      gridTemplateColumns: '1fr'
    }
  },
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '30px 40px 0px 40px'
  }
}));

type Props = {
  manager: OrgOverview_manager;
  purchasedCourses: OrgOverview_purchasedCourses;
};

const OrgOverview = ({ manager, purchasedCourses }: Props) => {
  const classes = useStyles();

  const { router } = useRouter();

  return (
    <div className={classes.root}>
      <div className={classes.pageHeader}>
        <PageHeader title="Dashboard" subTitle={manager.company.name} />
      </div>
      <div className={classes.grid}>
        <StatusCard company={manager.company} />
        <div className={classes.feedRow}>
          <ExpiringSoonCard company={manager.company} />
          <ActivityFeedCard company={manager.company} />
        </div>
      </div>
    </div>
  );
};

export default createFragmentContainer(OrgOverview, {
  manager: graphql`
    fragment OrgOverview_manager on Manager {
      firstName
      lastName
      email
      telephone
      lastLogin
      company {
        name
        delegates {
          pageInfo {
            total
          }
        }
        certificatesStatus {
          totals {
            available
            expired
            expiringSoon
            incomplete
          }
        }
        ...StatusCard_company
        ...ActivityFeedCard_company
        ...ExpiringSoonCard_company
      }
    }
  `,
  purchasedCourses: graphql`
    fragment OrgOverview_purchasedCourses on PurchasedCoursePage {
      edges {
        counts {
          expiringTakers
        }
      }
    }
  `
});
